module.exports = __webpack_public_path__ + "static/media/go-big-go-home-large-cta.bd8b3ca0.jpg";